// components/AuthenticatedLayout.jsx (DEMO)

import React from 'react';
import { Box } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

import SecondaryNavbar from './Nav/SecondaryNavbar';
import MiniDrawer from './Nav/Drawer';
import Footer from './Footer/Footer';
import AppSnackbar from './AppSnackbar';

const AuthenticatedLayout = ({ children }) => {
  const [open, setOpen] = React.useState(false);

  // you *can* still read access if you want, but we won't show PastDue stuff in demo
  // const access = useSelector((s) => s.access);
  // const navigate = useNavigate();

  return (
    <>
      <SecondaryNavbar open={open} setOpen={setOpen} />
      <MiniDrawer open={open} setOpen={setOpen} />
      <AppSnackbar />

      <Box
        component="main"
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '80vh',
        }}
      >
        {children}
      </Box>

      <Footer />
    </>
  );
};

export default AuthenticatedLayout;